module.exports = __webpack_public_path__ + "img/1521306264.a3302603.jpg";